import { Routes } from '@angular/router';
import { LoginComponent } from './components/auth/login/login.component';
import { RoleGuard } from './services/auth/guards/role-guard/role-guard';
import { canActivateGuard } from './services/auth/guards/canActivate/can-activate.guard';

export const routes: Routes = [
      { path: 'login', component: LoginComponent },
      { 
        path: 'dashboard', 
        loadComponent: () =>
        import('./components/dashboard/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [RoleGuard, canActivateGuard],
        data: { roles: ['Admin', 'Buero', 'Personal'] }
      },
      { 
        path: 'vorgang/:id', 
        loadComponent: () =>
        import('./components/vorgang/vorgang-detail-view/vorgang-detail-view.component').then(m => m.VorgangDetailViewComponent),
        canActivate: [RoleGuard, canActivateGuard],
        data: { roles: ['Admin', 'Buero', 'Personal'] }
      },
      { 
        path: 'inbox', 
        loadComponent: () =>
        import('./components/inbox/views/inbox.component').then(m => m.InboxComponent),
        canActivate: [RoleGuard, canActivateGuard],
        data: { roles: ['Admin', 'Buero', 'Personal'] }
      },
      { 
        path: 'inbox/:id', 
        loadComponent: () =>
        import('./components/inbox/views/inbox.component').then(m => m.InboxComponent),
        canActivate: [RoleGuard, canActivateGuard],
        data: { roles: ['Admin', 'Buero', 'Personal'] }
      },
      { path: '', redirectTo: '/login', pathMatch: 'full' },
      { path: '**', redirectTo: '/login' }
];
